import "./ServiceTiers.module.css";
import Header from "@/reusable_sections/Header";
import InvestmentInAutonomy from "./sections/InvestmentInAutonomy";
import CommonInquiries from "./sections/CommonInquiries";
import Footer from "@/reusable_sections/Footer";
export default function ServiceTiersPage() {
  return <div>
      <Header />
      <InvestmentInAutonomy />
      <CommonInquiries />
      <Footer />
    </div>;
}